import VSelectOptionDetail from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectOptionDetail', VSelectOptionDetail),
};
